import http from "../config";
const serve = process.env.VUE_APP_HUBEI;
//  const serve = '/api';
export default {
  // 获取k线图页面的参数选项
  getKLineParam() {
    return http.post(`${serve}/getKLineParam`);
  },
  // 获取k线图
  getKData(param) {
    return http.post(`${serve}/getKData`, param);
  },
  // 获取主图指标中的参数选项
  getIndexParam() {
    return http.post(`${serve}/getIndexParam`);
  },
  // 获取k线对应指标,每次获取一个，操作方式为循环获取
  getKLineIndex(param) {
    return http.post(`${serve}/getKLineIndex`, param);
  },
  // 获取副图指标中的参数选项
  getSubIndexParam() {
    return http.post(`${serve}/getSubIndexParam`);
  },

  // 获取单标的因子分析可选参数列表
  getSingleFactorParams() {
    return http.post(`${serve}/getSingleFactorParams`);
  },
  // 单标的因子分析
  getSymbolData(param) {
    return http.post(`${serve}/getFactorSingleSymbolData`, param);
  },

  // 获取单天，单/多因子，多标的分析的参数
  getDayFactorParams(param) {
    return http.post(`${serve}/getDayFactorParams`, param);
  },

  // 单天，多因子,多标的分析
  getFactorSymbolData(param) {
    return http.post(`${serve}/getFactorSymbolData`, param);
  },

  // 单因子分析-因子绩效
  getSingleFactorPerformance(param) {
    return http.post(`${serve}/getSingleFactorPerformance`, param);
  },
  // 获取绩效的参数
  getFactorPerformanceParams() {
    return http.post(`${serve}/getFactorPerformanceParams`);
  },
  // 获取策略列表
  getStrategyList(param) {
    return http.post(`${serve}/getStrategyList`, param);
  },

  // 获取參數详情
  getStrategyParamInfo(param) {
    return http.post(`${serve}/getStrategyParamInfo`, param);
  },

  // 获取策略文件内容
  getStrategyContent(param) {
    return http.post(`${serve}/getStrategyContent`, param);
  },

  // 获取策略回测绩效
  getStrategyPerformance(param) {
    return http.post(`${serve}/getStrategyPerformance`, param);
  },
  // 单因子分析-调仓记录
  getSingleFactorAdjustRecord(param) {
    return http.post(`${serve}/getSingleFactorAdjustRecord`, param);
  },
  // 单因子分析-根据筛选条件获取调仓记录
  getSingleFactorAdjustRecordByParm(param) {
    return http.post(`${serve}/getSingleFactorAdjustRecordByParm`, param);
  },
  // 获取会话id
  sessionId() {
    return http.post(`${serve}/session/sessionId`);
  },
  // 获取单标的因子分析可选参数列表
  sessionKeep() {
    return http.post(`${serve}/session/keep`);
  },
  
// 根据Code获取题目内容
examContent(param) {
  return http.post(`${serve}/exam/content`,{'stringList':param});
},

}